<template>
  <div
       v-if="!state.hotspotPopupVisible"
       @click="selectHotspot"
       :class="[
           'hotspot-dot-container',
           state.selectedHotspot.uuid === hotspot.uuid ? 'selected' : '',
           hotspot.alwaysShowLabelText ? '': 'on-hover',
           ]"
       :hotspotIndex="index"
       :slideUuid="activeSlideUuid"
       :style="{
                        left: hotspot.x || hotspot.x === 0 ? hotspot.x + '%' : 'unset',
                        top: hotspot.y || hotspot.y === 0 ? hotspot.y + '%' : 'unset'
                      }">
    <div
        v-if="hotspot.hotspotAction === 'popup'"
        class="extra-dot">
    </div>
    <div class="d-flex">
      <div
          :class="[
              'hotspot-icon',
              !editorMode ? 'pulsate' : '',
              state.activeColumn === 'hotspots' ? 'can-drag' : '',
              ]"
      />
      <div
          v-if="getLabel(hotspot, $store.getters.getSelectedFormLanguage)"
           :class="['custom-tooltip-1', hotspot.x <= 50 ? 'tooltip-right' : 'tooltip-left']"
           >
        {{ getLabel(hotspot, $store.getters.getSelectedFormLanguage) }}
      </div>
      <BUTTON_ITEM
          v-if="hotspot.hotspotAction === 'goto'"
          ref="hotspotButton"
          :config="hotspot"
          :lang="$store.getters.getSelectedFormLanguage"
          :state="state"
          style="display: none"
          @goToProject="goToProject"
          @goToProjectSlide="goToProjectSlide"
          @goToSlide="goToSlide"
          @goToStep="goToStep"
          @nextSlide="nextSlide"
          @next="nextSlide"/>
    </div>
  </div>
</template>

<script>
import BUTTON_ITEM from "@/components/vForm/viewer/BUTTON_ITEM.vue";

export default {
  name: "Hotspot" ,
  components: {BUTTON_ITEM},
  props: {
    hotspot: {type: Object, required: true},
    activeSlideUuid: {type: String, required: true},
    editorMode: {type: Boolean, default: false},
    state: {type: Object, required: true},
    index: {type: Number, default: 0},
  },
  methods: {
    selectHotspot() {
      //allow to select hotspot only if popup is closed
      if (!this.state.hotspotPopupVisible) {
        const canShowPopup = this.state.activeColumn !== "hotspots";
        this.state.selectedHotspot =this.hotspot;
        if (this.editorMode) {
          if (this.hotspot.hotspotAction === 'popup') {
            this.state.hotspotPopupVisible = canShowPopup;
          } else {
            //this.state.activeColumn = 'hotspots';
          }
        } else {
          if (this.hotspot.hotspotAction === 'popup') {
            this.state.hotspotPopupVisible = canShowPopup;
          } else {
            this.$refs.hotspotButton.click();
          }
        }
      }
    },
    getLabel(config, lang) {
      if (config.label && config.label.dix) {
        return config.label.dix[lang] ? config.label.dix[lang] : config.label.dix.Unknown;
      }

      return '';
    },
    nextSlide() {
      this.$emit("nextSlide", {});
    },
    goToSlide(uuid) {
      this.$emit("goToSlide", uuid, {});
    },
    goToSlideNo(no) {
      this.$emit("goToSlideNo", no, {});
    },
    goToStep(stepUuid) {
      this.$emit("goToStep", stepUuid, {});
    },
    goToProjectSlide(projectUuid, projectName, targetSlide = null) {
      this.$emit("goToProjectSlide", projectUuid, projectName, targetSlide, {});
    },
    goToProject(projectUuid, projectName, targetStep = null) {
      this.$emit("goToProject", projectUuid, projectName, targetStep, {});
    },
  }
}
</script>

<style scoped lang="scss">
// make a fade in animation for the hotspot container
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.hotspot-dot-container {
  pointer-events: all;
  position: absolute;
  cursor: pointer;
  z-index: 2;
  animation: fadeIn 600ms ease-in;
  .extra-dot {
    width: 8px;
    height: 8px;
    border: 2px solid white;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
  }

  &.learn.selected {
    box-shadow: 0 0 9px 6px white;
  }
  &.on-hover {
    .tooltip-right, .tooltip-left {
      opacity: 0;
      transition: all 200ms ease;
    }
    :hover {
      .tooltip-right, .tooltip-left {
        opacity: 1;
      }
    }
  }
}
.hotspots-active {
  z-index: 30;

  &.panel-visible {
    opacity: 0.8;
  }
}

.hotspot-icon {
  width: 20px;
  height: 20px;
  background-color: orangered;
  border-radius: 50%;
  box-shadow: 0 0 5px 3px white;
  z-index: 2;

  &.pulsate {
    animation-name: stretch;
    animation-duration: 1.0s;
    animation-timing-function: ease-out;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-play-state: running;

    &:hover {
      //animation: none;
    }
  }

  &.can-drag {
    background-size: 5px 5px;
    background-image: linear-gradient(to right, darkred 1px, transparent 1px),
    linear-gradient(to bottom, darkred 1px, transparent 1px);
    border-color: darkred;
  }

  &.learn {
    &.can-drag {
      background-size: 5px 5px;
      background-image: none;
    }

    background-color: #6a6ade;
    border-radius: 5%;
    width: fit-content;
    min-width: 35px;
    padding: 0 8px 0 8px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;

    &.case-2 {
      background-color: #1e7e34;
    }

    .no-selection {
      padding-bottom: 2px;
    }

    &.select-active {
      width: 42px;
    }
  }
}

@keyframes stretch {
  0% {
    transform: scale(0.9);
  }

  50% {
  }

  100% {
    transform: scale(1.3);
  }
}

.custom-tooltip-1 {
  white-space: nowrap;
  position: absolute;
  background-color: white;
  border-radius: 25px;
  z-index: 0;
  align-items: center;
  top: -3px;
  bottom: -3px;
  padding: 0 0.5em;
  display: flex;
  font-size: 1.05em;
  transition: all 300ms ease;
}

.tooltip-left {
  right: -4px;
  padding-right: calc(30px + 0.5em);
}

.tooltip-right {
  left: -4px;
  padding-left: calc(30px + 0.5em);
}

.hotspot-container.dont-you-dare-do-any-transitions {
  .hotspot-icon {
    animation-name: none !important;
    animation-duration: 0s !important;
    opacity: 1 !important;
    transition: none !important;
    transform: scale(1.2);
  }
  .hotspot-dot-container {
    animation-name: none !important;
    animation-duration: 0s !important;
    opacity: 1 !important;
    transition: none !important;
  }
  .custom-tooltip-1 {
    animation-name: none !important;
    animation-duration: 0s !important;
    opacity: 1 !important;
    transition: none !important;
  }
  .tooltip-right, .tooltip-left {
    opacity: 1 !important;
    transition: none !important;
    color: #000;
  }
}
</style>